import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import ErrorBoundary from './components/ErrorBoundary';
import CardSearchPage from './pages/CardSearchPage';
import CardDetailPage from './pages/CardDetailPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import DecksPage from './pages/DecksPage';
import DeckBuilderPage from './pages/DeckBuilderPage';
import PlaytestPage from './pages/PlaytestPage';
import ProfilePage from './pages/ProfilePage';
import RulingsPage from './pages/RulingsPage';
import DuelHomePage from './pages/DuelHomePage';
import DuelPage from './pages/DuelPage';

// Data router (createBrowserRouter) so pages can use useBlocker to guard
// unsaved changes against in-app navigation + the back button.
const router = createBrowserRouter([
  { path: '/', element: <CardSearchPage /> },
  { path: '/card/:name', element: <CardDetailPage /> },
  { path: '/decks', element: <DecksPage /> },              // public browse + your decks
  { path: '/deck/:id', element: <DeckBuilderPage /> },     // privacy-gated view; owner edits
  { path: '/deck/:id/:slug', element: <DeckBuilderPage /> },
  { path: '/playtest/:id', element: <PlaytestPage /> },    // top-level so a deck named "playtest" can't collide
  { path: '/playtest/:id/:slug', element: <PlaytestPage /> },
  { path: '/user/:userId', element: <ProfilePage /> },
  { path: '/duel', element: <DuelHomePage /> },           // create/join (sign-in gated in-page)
  { path: '/duel/:id', element: <DuelPage /> },
  { path: '/rulings', element: <RulingsPage /> },
  { path: '/login', element: <LoginPage /> },
  { path: '/register', element: <RegisterPage /> },
  { path: '*', element: <CardSearchPage /> },
]);

function App() {
  return (
    <AuthProvider>
      <ErrorBoundary>
        <RouterProvider router={router} />
      </ErrorBoundary>
    </AuthProvider>
  );
}

export default App;
